<template>
  <div class="z-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-80">
    <img src="@/assets/images/loader/loader.gif" class="size-20" alt="loader" />
  </div>
</template>
